export configDataTypes = {
  string: 'string'
  file: 'file'
  number: 'number'
  integer: 'integer'
  boolean: 'boolean'
  array: 'array'
  object: 'object'
}